import { render, staticRenderFns } from "./SettingCustomersCustomerDefaultGroup.vue?vue&type=template&id=53bb7edf&"
import script from "./SettingCustomersCustomerDefaultGroup.vue?vue&type=script&lang=ts&"
export * from "./SettingCustomersCustomerDefaultGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports